'use client';

import { useEffect } from 'react';
import { trackEvent } from '@/lib/monitoring/appInsights';

export default function PageNotFoundTracker() {
  useEffect(() => {
    trackEvent('PageNotFound', {
      url: typeof window !== 'undefined' ? window.location.href : '',
    });
  }, []);

  return null;
}
